import { EnvironmentTypes, GameModes } from '@pascal/pascal-core';

export const AppDefaultValuesEnum = {
  LANGUAGE: 'en',
  MODE: GameModes.Fun,
  APPLICATION_ID: process.env.REACT_APP_ENV === EnvironmentTypes.Production ? 23 : 29,
};
